import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import type { OfferDurationOption } from 'components/OfferPage/Filters/DurationTabs/OfferDurationTabs'
import { getDurationOptions } from 'selectors/offerPage/offerPageSelectors'
import { getMultiRoomDurationOptions } from 'selectors/offerPage/multipleRoomBookingSelectors'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'

interface ShouldSkipFlashDurationStepParams {
  isExperimentEnabled: boolean
  durationSelected?: boolean
  currentDuration?: number
  defaultDuration?: number
  firstAvailableDuration?: number
}

export function getFlashCalendarSkipDurationOptions(
  offerPageState: OfferPageState,
  appState: App.State,
): Array<OfferDurationOption> {
  return isMultipleRoomBookingActive(offerPageState, appState)
    ? getMultiRoomDurationOptions(offerPageState, appState)
    : getDurationOptions(offerPageState, appState)
}

export function getFirstAvailableDuration(
  durationOptions: Array<OfferDurationOption>,
): number | undefined {
  return durationOptions.find(option => !option.soldOut)?.duration
}

export function shouldSkipFlashDurationStep({
  isExperimentEnabled,
  durationSelected,
  currentDuration,
  defaultDuration,
  firstAvailableDuration,
}: ShouldSkipFlashDurationStepParams): boolean {
  return (
    isExperimentEnabled &&
    !durationSelected &&
    defaultDuration != null &&
    firstAvailableDuration != null &&
    currentDuration === defaultDuration
  )
}
